export const CardWithC4CssProps = {
  width: '25%',
  display: 'inline-block',
  height: 'max-content',
  minHeight: '155px',
  overflow: 'hidden',
};

export const CardWithC3CssProps = {
  width: '33%',
  display: 'inline-block',
  height: 'max-content',
  minHeight: '155px',
  overflow: 'hidden',
};

export const CardWithC2CssProps = {
  width: '50%',
  display: 'inline-block',
  height: 'max-content',
  minHeight: '155px',
  overflow: 'hidden',
};
